import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { AppContext } from '../../App';
import ProductService from '../../services/ProductService';

const Product = () => {
  const { addListeners, showNotification, errorNotification } =
    React.useContext(AppContext);
  const [productService] = useState(new ProductService());

  const [product, setProduct] = useState(null);

  let { id } = useParams();

  useEffect(() => {
    productService
      .GetProduct(id)
      .then((result) => {
        if (result.success) {
          setProduct(result.payload);
        } else {
          showNotification(
            'error',
            'Error while getting product',
            10,
            'Error getting product'
          );
        }
      })
      .catch((error) => {
        errorNotification(error, 'Error getting product');
      })
      .finally(() => {});
  }, []);

  useEffect(() => {
    if (product) {
      addListeners();
    }
  }, [product]);

  return (
    <main id="main">
      <br />
      <br />
      <br />
      <section id="breadcrumbs" className="breadcrumbs">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <h2>Product Details</h2>
          </div>
        </div>
      </section>
      <section id="portfolio-details" className="portfolio-details">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-8">
              <div className="portfolio-details-slider swiper">
                <div className="swiper-wrapper align-items-center">
                  {product?.images.map((item) => (
                    <div key={item.id} className="swiper-slide">
                      <img
                        src={productService.GetProductImageUrl(item.id)}
                        alt=""
                      />
                    </div>
                  ))}
                </div>
                <div className="swiper-pagination"></div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="portfolio-description">
                <h2>{product?.title}</h2>
                <div style={{ whiteSpace: 'pre-wrap' }}>
                  {product?.description}
                </div>
                <br />
                <br />
                <br />
                <div>
                  <p className="p-0 m-0">
                    For further information please contact us:
                  </p>
                  <p>
                    <a href="mailto: jovanovskiLaboratory@gmail.com">
                      jovanovskiLaboratory@gmail.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Product;
